<template>
  <NavbarLayout />
  <SidebarLayout />
  <v-main :class="['bg-white', $attrs.class]" id="content" class="main-with-footer">
    <div class="main-footer-wrapper">
      <div class="main-content">
        <slot></slot>
      </div>
      <FooterLayout />
    </div>
  </v-main>
</template>

<script>
import FooterLayout from "./FooterLayout.vue";
import NavbarLayout from "./NavbarLayout.vue";
import SidebarLayout from "./SidebarLayout.vue";

export default {
  name: "DefaultLayout",
  components: { NavbarLayout, SidebarLayout, FooterLayout },
};
</script>

<style scoped>
.main-with-footer {
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.main-footer-wrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 100%;
}

.main-content {
  flex: 1 0 auto;
}
</style>
